<template>
  <tbody>
    <tr>
      <td class="text-white text-center" :class="{ 'bg-success': read,  'bg-danger': !read }">
        {{ parseInt(index) + 1}}
      </td>
      <td :class="{ 'font-weight-bold': !read }">
        {{ notification.data.item }}
      </td>
      <td :class="{ 'font-weight-bold': !read }">
        {{ client }}
      </td>
      <td :class="{ 'font-weight-bold': !read }">
        {{ notification.data.type }}
      </td>
      <td :class="{ 'font-weight-bold': !read }">

        <span class="a" @click.prevent="readInternal" v-if="notification.data.internal">Learn More</span>

        <InertiaLink v-else @click="markAsRead" :href="notification.data.action">
          Review document
        </InertiaLink>

      </td>
    </tr>
    <tr v-if="showing">
      <td></td>
      <td
        class="border border-left-0 border-right-0 bg-light whitespace-pre-line"
        colspan="4"
        v-html="notification.data.message"
      />
    </tr>
    <tr v-if="showing" class="bg-white">
      <td class="border-0" colspan="5"><p></p></td>
    </tr>
  </tbody>
</template>

<script>
export default {
  props: {
    index: Number,
    notification: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      showing: false,
      read: !!this.notification.read_at,
    };
  },

  computed: {
    client() {
      return this.$page.props.auth.user.organisation.id === this.notification.data.originator_id ? this.notification.data.client : this.notification.data.originator;
    },
  },

  methods: {
    markAsRead() {
      window.axios
        .put(`/notification/${this.notification.id}`)
        .then(() => {
          this.read = true;
        });
    },

    readInternal() {
      this.markAsRead();
      this.showing = !this.showing;
    },
  },
};
</script>
